import { render } from "./ForgetPassword.vue?vue&type=template&id=5abd433a&scoped=true"
import script from "./ForgetPassword.vue?vue&type=script&lang=js"
export * from "./ForgetPassword.vue?vue&type=script&lang=js"

import "./ForgetPassword.vue?vue&type=style&index=0&id=5abd433a&scoped=true&lang=scss"
import "./ForgetPassword.vue?vue&type=style&index=1&id=5abd433a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5abd433a"]])

export default __exports__